import { useLang } from "@/i18n";
import { Eyebrow, Reveal } from "./Reveal";

export const Method = () => {
  const { t } = useLang();

  return (
    <section id="methode" data-testid="method-section" className="bg-[#FBF8F3] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mb-16 max-w-2xl">
          <Eyebrow>{t.method.eyebrow}</Eyebrow>
          <h2 className="mt-6 font-display text-3xl font-semibold leading-[1.15] tracking-tight text-[#0A1F18] sm:text-4xl lg:text-5xl">
            {t.method.title}
          </h2>
          <p className="mt-6 text-base leading-relaxed text-[#5C6B64]">{t.method.sub}</p>
        </Reveal>

        <div>
          {t.method.steps.map((step, i) => (
            <Reveal key={step.title} delay={i * 0.08}>
              <div
                data-testid={`method-step-${i}`}
                className="group grid items-start gap-4 border-t border-[#E4DDD0] py-10 transition-colors duration-500 last:border-b hover:bg-white sm:grid-cols-[120px_1fr_1.4fr] sm:gap-10 sm:px-6"
              >
                <span className="font-mono text-sm tracking-[0.3em] text-[#B36C45]">
                  / 0{i + 1}
                </span>
                <h3 className="font-serif text-2xl font-medium italic tracking-tight text-[#0A1F18] transition-transform duration-500 group-hover:translate-x-2 sm:text-3xl">
                  {step.title}
                </h3>
                <p className="max-w-xl text-base leading-relaxed text-[#5C6B64]">{step.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
